"use client"

import clsx from "clsx"
import { AnimatePresence } from "framer-motion"
import React, { useEffect, useRef, useState } from "react"

import PageGrid from "../../PageGrid"

// import MenuDesktop from './MenuDesktop'
import { NavItem } from "../types/navigation"

import NavButton from "./NavButton"

interface INavDesktopProps {
  navOpen: boolean
  navData: NavItem[]
  setNavOpen?: React.MouseEventHandler
  allowHover: boolean
}

const NavDesktop: React.FC<INavDesktopProps> = ({
  navOpen,
  navData,
  setNavOpen,
  allowHover,
}) => {
  const [activeIndex, setActiveIndex] = useState(null)
  const prevActiveIndex = useRef(0)

  // This effect will run on both the first render and after every update. After the DOM has updated
  // to the new activeIndex the ref will update and point at the activeIndex stored in the state.
  // Essentially this results in, for example, activeIndex being 1 and prevActiveIndex being 0.
  // This is used in the NavButton component to trigger the correct animations, left, right, etc.
  useEffect(() => {
    prevActiveIndex.current = activeIndex
    setActiveIndex(allowHover === false ? null : activeIndex)
  })

  return (
    <AnimatePresence>
      <PageGrid className="relative z-0 hidden lg:block" isGrid={false}>
        <nav
          className={clsx(
            "flex flex-col lg:w-full lg:flex-row lg:justify-center",
          )}
        >
          {navData.map((navItem, index) => (
            <NavButton
              key={navItem.name}
              navItem={navItem}
              index={index}
              setActiveIndex={setActiveIndex}
              activeIndex={activeIndex}
              setNavOpen={setNavOpen}
              navOpen={navOpen}
              menuData={navData}
              allowHover={allowHover}
            />
          ))}
        </nav>
      </PageGrid>
    </AnimatePresence>
  )
}

export default NavDesktop
